import { render } from "./LogoutPage.vue?vue&type=template&id=5f4a4b1b"
import script from "./LogoutPage.vue?vue&type=script&lang=js"
export * from "./LogoutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__